import { render, staticRenderFns } from "./ZT_1D_positioning-modal.vue?vue&type=template&id=c242ff92&scoped=true"
import script from "./ZT_1D_positioning-modal.vue?vue&type=script&lang=js"
export * from "./ZT_1D_positioning-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c242ff92",
  null
  
)

export default component.exports